import React from 'react';
import { Box, Checkbox, useColorMode } from '@tonic-ui/react';

import styles from './questionnaire.module.css';

interface ProfilingModalTileProps {
  choiceId: string;
  choice: string;
  checked: boolean;
  disabled: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const ProfilingModalTile = ({
  choiceId,
  choice,
  checked = false,
  disabled = false,
  onChange,
}: ProfilingModalTileProps): JSX.Element => {
  const [colorMode] = useColorMode();
  const colorModeClass = colorMode === 'dark' ? styles.dark : '';

  return (
    <Box
      fontSize="md"
      className={`${styles.tile} ${disabled ? styles.tileDisabled : ''} ${colorModeClass}`}
      data-id={`onboarding-question-${choiceId}`}
      data-telemetry-id={`onboarding-question-${choiceId}`}
    >
      <Checkbox padding="4x" width="100%" checked={checked} disabled={disabled} onChange={onChange}>
        {choice}
      </Checkbox>
    </Box>
  );
};

ProfilingModalTile.displayName = 'ProfilingModalTile';

export default ProfilingModalTile;
